import { Component, Input, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { ConciliacionBancaria } from '../../../models/conciliacion-bancaria';
import { ConciliacionBancariaService } from '../../../services/conciliacion-bancaria.service';
import { MovimientoBancoService } from '../../../services/movimiento-banco.service';

@Component({
  selector: 'app-conciliacion-modal',
  templateUrl: './conciliacion-modal.component.html',
  styleUrls: ['./conciliacion-modal.component.css'],
  providers: [
    ConciliacionBancariaService,
    MovimientoBancoService
  ]
})
export class ConciliacionModalComponent implements OnInit {

  @Input() conciliacion_id: string;
  public conciliacion_bancaria: any;
  public loading: boolean;
  public movimiento_detalle: any;
  public format_decimal: string;
  public movimientos: any;
  public saldo_final: any;
  public saldo_inicial: any;
  public diferencia_grid: any;
  public movimientos_activos: Array<any>;
  constructor(
    public conciliacionService: ConciliacionBancariaService,
    public bsModalRef: BsModalRef,
    public movimientoBancoService: MovimientoBancoService,
  ) {
    this.conciliacion_bancaria = new ConciliacionBancaria();

    this.movimiento_detalle = [];
    this.loading = false;
    this.format_decimal = "0,0.00";
    this.movimientos = [];
    this.saldo_final = 0;
    this.saldo_inicial = 0;
    this.diferencia_grid = 0;
    this.movimientos_activos = [];

  }

  ngOnInit() {
    this.loading = true;
    let p1 = this.getDataConciliacion();
    Promise.all([p1]).then(
      res => this.loading = false,
      err => this.loading = false,
    )
  }

  getDataConciliacion() {
    return new Promise((resolve, reject) => {

      this.conciliacionService.getById(this.conciliacion_id, "?embed=cuentabancaria").subscribe(
        res => {
          this.conciliacion_bancaria = res.data;
          this.getDataMovimiento();
          this.getDiferencia();

          resolve(true);
        }, err => {
          reject(err);
          this.conciliacion_bancaria = new ConciliacionBancaria();
        }
      );


    });
  }
  getFilters() {
    let qs = "";
    if (this.conciliacion_bancaria.cuenta_bancaria_id) {
      qs += "?cuenta_bancaria_id=" + this.conciliacion_bancaria.cuenta_bancaria_id;
    }
    if (this.conciliacion_bancaria.id) {
      qs += "&conciliacion_bancaria_id=" + this.conciliacion_bancaria.id;
    }
    return qs;
  }
  getDataMovimiento() {
    let qs = "";
    if (this.conciliacion_bancaria.cuenta_bancaria_id) {
      qs += "?cuenta_bancaria_id=" + this.conciliacion_bancaria.cuenta_bancaria_id;
    }
    if (this.conciliacion_bancaria.id) {
      qs += "&conciliacion_bancaria_id=" + this.conciliacion_bancaria.id;
    }
    this.movimientoBancoService.getDetalles(qs + "&fecha_corte=" + this.conciliacion_bancaria.fecha_corte + "&status=I").subscribe(
      res => {
        this.movimientos = res;
        // this.movimientos.sort((a,b)=>{
        //   return a.movimiento_banco_id - b.movimiento_banco_id;
        // });
        // this.saldo_contable = 0;
        // this.movimientos.forEach(m => this.saldo_contable += parseFloat(m.monto));


      }, err => {
        this.movimientos = [];
      }
    );
  }
  getDiferencia() {
    let sum_mov_inactivos = 0;
    let mov_pago = 0;

    let qs = "";
    if (this.conciliacion_bancaria.cuenta_bancaria_id) {
      qs += "?cuenta_bancaria_id=" + this.conciliacion_bancaria.cuenta_bancaria_id;
    }

    this.movimientoBancoService.getDetalles(qs + "&fecha_corte=" + this.conciliacion_bancaria.fecha_corte + "&status=A").subscribe(
      res => {
        this.movimientos_activos = res;
        this.movimientos_activos.forEach(movimiento => {
          sum_mov_inactivos += parseFloat(movimiento.monto);
        });
        if (this.movimientos_activos.length > 0) {
          this.diferencia_grid = sum_mov_inactivos;
        }
      }, err => {
        this.movimientos_activos = [];
      }
    );




  }

  getDescripcion(movimiento) {
    let descripcion = '';
    if (movimiento.tipo == 'C') {
      descripcion = movimiento.cliente_proveedor + ' - ' + movimiento.nro_comprobante;
    } else {
      descripcion = movimiento.cliente_proveedor + ' - ' + movimiento.nro_comprobante;
    }
    return descripcion;
  }


}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/modals/conciliacion-modal/conciliacion-modal.component.ts